<template>
    <vl-sidebar-content class="kl-sidebar__section">
        <div class="kl-sidebar__section__edit-zone-detail">
            <div class="kl-sidebar__section__edit-zone-detail__col2-2">
                <strong class="kl-sidebar__text13">OPPERVLAKTE</strong>
                <div v-html="formattedArea"></div>
            </div>
            <div class="kl-sidebar__section__vertical-separator"></div>
            <div class="kl-sidebar__section__edit-zone-detail__col2-2">
                <strong class="kl-sidebar__text13">PROJECTIE</strong>
                <div v-html="formattedProjection"></div>
            </div>
        </div>
    </vl-sidebar-content>
</template>

<script lang="ts">
import {computed, defineComponent, inject, Ref, ref, watch} from 'vue';
import {getProjectionLabel} from '@/app/shared/components/ippro-map/projection/projection-utils';
import KlDrawZoneMapUtils from '../kl-draw-zone-map-utils';
import {IDrawZoneFeatureContext} from '../kl-draw-zone-feature-context';

export default defineComponent({
    name: 'KlDrawZoneSidebarAreaSection',
    props: {},
    setup(props, { emit }) {
        const _context = inject<IDrawZoneFeatureContext>('kl-draw-zone-map-feature-context');

        const formattedArea: Ref<string> = ref<string>('-');
        const formattedProjection = computed((): string => getProjectionLabel(_context.projectionRef.value));

        watch (
            _context.currentAreaRef,
            (newArea: number) => {
                formattedArea.value = KlDrawZoneMapUtils.formatAreaSimple(newArea);
            },
            { immediate: true });

        return {
            formattedProjection,
            formattedArea,
        }
    }
})
</script>

